// extracted by mini-css-extract-plugin
export default {"p_tye":"_739344648c","slcted":"_8f1c6b9e27","slc_color":"_557cf4e88a","item_p":"ed4da32454","r0":"c8799b554b"};